import { useEffect, useState, useContext, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import {
  Container,
  Typography,
  Button,
  Alert,
  LinearProgress,
} from '@mui/material';
import AuthContext from '../AuthContext';
import { apiFetch } from '../api';

export default function AdminReviewPage() {
  const { id } = useParams();
  const [log, setLog] = useState(null);
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [approving, setApproving] = useState(false);
  const { token } = useContext(AuthContext);
  const fetchData = useCallback(async () => {
    try {
      const logResp = await apiFetch(`/api/logs/${id}/`, {
        headers: token ? { Authorization: `Token ${token}` } : {},
      });
      if (!logResp.ok) {
        throw new Error('Failed to fetch log');
      }
      const logData = await logResp.json();
      setLog(logData);

      const response = await apiFetch(`/api/admin/logs/${id}/results/`, {
        headers: token ? { Authorization: `Token ${token}` } : {},
      });
      if (!response.ok) {
        throw new Error('Failed to fetch results');
      }
      const data = await response.json();
      setResults(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [id, token]);

  useEffect(() => {
    if (token) {
      fetchData();
    }
  }, [fetchData, token]);

  const handleApprove = async () => {
    setApproving(true);
    try {
      const response = await apiFetch(`/api/admin/logs/${id}/advance/`, {
        method: 'POST',
        headers: token ? { Authorization: `Token ${token}` } : {},
      });
      if (!response.ok) {
        throw new Error('Failed to approve stage');
      }
      await fetchData();
    } catch (err) {
      setError(err.message);
    } finally {
      setApproving(false);
    }
  };

  if (error) {
    return (
      <Container sx={{ py: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Container>
    );
  }

  if (loading) {
    return (
      <Container sx={{ py: 4 }}>
        <LinearProgress />
      </Container>
    );
  }

  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Review Log {log.visible_name || log.file.split('/').pop()}
      </Typography>
      <pre style={{ background: '#f5f5f5', padding: '1rem', overflowX: 'auto' }}>
        {JSON.stringify(results, null, 2)}
      </pre>
      <Button
        variant="contained"
        sx={{ mt: 2 }}
        onClick={handleApprove}
        disabled={approving}
      >
        Approve Stage
      </Button>
    </Container>
  );
}
